<template lang="pug">
Global(v-bind="$props")
  slot
</template>

<script>
import styled from "vue-styled-components"
import { transparentize, darken } from "polished"

export const Global = styled("div")`
  font-family: ${props => props.theme.font.family};
  overflow: hidden !important;
  position: relative;
  font-size: ${props => props.theme.font.size};
  font-weight: ${props => props.theme.font.light};
  color: ${props => props.theme.color.onSurface};
  line-height: ${props => props.theme.font.lineHeight};
  user-select: none;

  .animated,
  .themed {
    ${props => props.theme.options.animate && "transition: all 0.2s ease-in-out;"}

    /* For SVG */
    path {
      ${props => props.theme.options.animate && "transition: all 0.2s ease-in-out;"}
    }
  }

  .primary-bg {
    background: ${props => props.theme.color.primary};
  }

  .active-element {
    background: ${props => props.theme.color.primary};
    color: ${props => props.theme.color.onPrimary};
  }

  .inactive-element {
    background: ${props => darken(0.15, props.theme.color.onPrimary)};
    color: ${props => props.theme.color.surface};
  }

  .active-reversed-element {
    background: ${props => props.theme.color.onPrimary};
    color: ${props => props.theme.color.primary};
  }

  .surface-bg {
    background: ${props => props.theme.color.surface};
  }

  .surface-bg-90 {
    background: ${props => transparentize(0.1, props.theme.color.surface)};
  }

  .surface-bg-darker {
    background: ${props => darken(0.05, props.theme.color.surface)};
  }

  .surface-bg-darker-90 {
    background: ${props => transparentize(0.1, darken(0.05, props.theme.color.surface))};
  }

  .onSurface-bg {
    background: ${props => props.theme.color.onSurface};
  }

  .primary-color {
    color: ${props => props.theme.color.primary};
  }

  .surface-color {
    color: ${props => props.theme.color.surface};
  }

  .onSurface-color {
    color: ${props => props.theme.color.onSurface};
  }

  .text-muted {
    color: ${props => transparentize(0.45, props.theme.color.onSurface)} !important;
  }

  .border,
  .border-left,
  .border-right,
  .border-top,
  .border-bottom {
    border-color: ${props => props.theme.color.border} !important;
  }

  *::-webkit-scrollbar {
    width: 10px;
    background: ${props => transparentize(0.9, props.theme.color.onPrimary)};
  }

  *::-webkit-scrollbar-thumb {
    background: ${props => props.theme.color.onPrimary};
  }

  .nv-scope-current {
    &::-webkit-scrollbar-thumb {
      background: ${props => props.theme.color.primary};
    }
  }
  .nv-el-current {
    ::-webkit-scrollbar-thumb {
      background: ${props => props.theme.color.primary};
    }

    .active-element {
      background: ${props => props.theme.color.onPrimary};
      color: ${props => props.theme.color.primary};
    }

    .active-reversed-element {
      background: ${props => props.theme.color.primary};
      color: ${props => props.theme.color.onPrimary};
    }

    &.text-muted,
    .text-muted {
      ${props => "color:" + transparentize(0.45, props.theme.color.onPrimary) + "!important;"}
    }

    &.bordered,
    &.themed,
    .themed,
    .bordered {
      border-color: ${props => props.theme.color.primary} !important;
    }

    &.colored,
    .colored {
      color: ${props => props.theme.color.primary} !important;
    }

    &.background,
    &.themed,
    .themed,
    .background {
      ${props =>
        props.theme.options.outline
          ? "background: transparent;" + "border-color:" + props.theme.color.primary + " !important;"
          : "background: " +
            props.theme.color.primary +
            " !important;" +
            "color:" +
            props.theme.color.onPrimary +
            " !important;" +
            "path {color:" +
            props.theme.color.onPrimary +
            " !important;}"}
    }

    &.backgroundTo,
    .backgroundTo {
      ${props => "background: -webkit-linear-gradient(270deg, transparent 0%, " + props.theme.color.primary + " 100%) !important;"}
    }

    &.backgroundFrom,
    .backgroundFrom {
      ${props => "background: -webkit-linear-gradient(270deg, transparent 0%, " + props.theme.color.surface + " 100%);"}
    }

    &.shadow,
    &.themed,
    .themed,
    .shadow {
      ${props => props.theme.options.shadow && "box-shadow: 0px 27px 18px -19px rgba(0,0,0,0.75) !important;"}
    }

    &.scale,
    &.themed,
    .themed,
    .scale {
      ${props => props.theme.options.scale && "transform: scale(1.2);"}
    }

    &.scale-xs,
    .scale-xs {
      ${props => props.theme.options.scale && "transform: scale(1.05);"}
    }

    &.scale-sm,
    .scale-sm {
      ${props => props.theme.options.scale && "transform: scale(1.1);"}
    }

    &.scale-lg,
    .scale-lg {
      ${props => props.theme.options.scale && "transform: scale(1.3);"}
    }

    &.scale-xl,
    .scale-xl {
      transform: scale(1.5);
    }

    &.scale-none,
    .scale-none {
      transform: scale(1) !important;
    }
  }
`
export default {
  name: "pr-global",
  components: {
    Global
  }
}
</script>
